document.addEventListener('DOMContentLoaded', function () {
    const jsMore = document.querySelectorAll('.jsMore');

    for (let index = 0; index < jsMore.length; index++) {
        let item = jsMore[index];
        let body = item.querySelector('.jsMoreBody');
        let content = item.querySelector('.jsMoreContent');
        let button = item.querySelector('.jsMoreTrigger');

        if(body.offsetHeight < content.offsetHeight) {
            button.classList.add('is-visible')
        } else {
            button.classList.remove('is-visible')
        }

        button.addEventListener('click', () => {
            body.classList.toggle('is-active');
            button.classList.toggle('is-active');

            if(body.classList.contains('is-active')){
                body.style.maxHeight = content.offsetHeight + 'px';
            } else {
                body.style.maxHeight = '';
            }
        })
    }
})

